import { HoverHelp } from '@/tableControls'
import { BARE_TRIGGER } from './gridClasses'

type NoteMarkerProps = {
  note: string
  context: string
  variant?: 'note' | 'rationale'
}

export default function NoteMarker({ note, context, variant = 'note' }: NoteMarkerProps) {
  const borderColor = variant === 'rationale' ? 'border-t-sky-700' : 'border-t-amber-600'
  return (
    <span className={`absolute right-0 top-0 leading-none ${BARE_TRIGGER}`}>
      <HoverHelp
        aria-label={variant === 'rationale' ? `Rationale — ${context}` : `Cell note — ${context}`}
        label={
          <span
            className={`block h-0 w-0 border-l-[7px] border-t-[7px] border-l-transparent ${borderColor}`}
          />
        }
      >
        <p className="text-sm text-gray-600">{note}</p>
      </HoverHelp>
    </span>
  )
}
